import http from '../../../services/api'
import type { APIResponse } from '../../../services/types'
import type { ItemUnitConversionApi, ItemUnitConversionCreateInput, ItemUnitConversionUpdateInput } from '../types'

const apiPath = import.meta.env.VITE_API_PATH

function conversionsPath(itemUuid: string): string {
  return `${apiPath}items/${itemUuid}/unit-conversions`
}

async function getItemUnitConversions(itemUuid: string) {
  return await http.get<APIResponse<ItemUnitConversionApi[]>>(conversionsPath(itemUuid))
}

async function createItemUnitConversion(itemUuid: string, input: ItemUnitConversionCreateInput) {
  return await http.post<APIResponse<ItemUnitConversionApi>>(conversionsPath(itemUuid), input)
}

async function updateItemUnitConversion(
  itemUuid: string,
  conversionUuid: string,
  input: ItemUnitConversionUpdateInput,
) {
  return await http.put<APIResponse<ItemUnitConversionApi>>(`${conversionsPath(itemUuid)}/${conversionUuid}`, input)
}

async function deleteItemUnitConversion(itemUuid: string, conversionUuid: string) {
  return await http.delete<APIResponse<null>>(`${conversionsPath(itemUuid)}/${conversionUuid}`)
}

const itemUnitConversionsService = {
  getItemUnitConversions,
  createItemUnitConversion,
  updateItemUnitConversion,
  deleteItemUnitConversion,
}

export default itemUnitConversionsService
